// extracted by mini-css-extract-plugin
module.exports = {"root":"root-3PptW","control":"control-p6Ziw","control__edit":"control__edit-3FBPP","price":"price-25vRr","price__selected":"price__selected-2eqQH"};